import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import LocationBodyTypography from 'bento-ordering/locations/components/LocationBodyTypography';
import { ITEM_DESCRIPTION_AND_PRICES } from 'styles/constants/appearanceSectionNames';

const LocationsCustomMessage = ({ message }) => {
  return (
    <Box
      sx={{
        marginBottom: '23px'
      }}
      data-testid="custom-message"
    >
      <LocationBodyTypography variant={ITEM_DESCRIPTION_AND_PRICES}>
        {message}
      </LocationBodyTypography>
    </Box>
  );
};

LocationsCustomMessage.propTypes = {
  message: PropTypes.string
};
export default LocationsCustomMessage;
